import AppStore from "@/assets/AppStore.svg";
import GooglePlay from "@/assets/GooglePlay.svg";
import { useLogin } from "@/context/useLoginProps";
import { prepareRightFooterData } from "@/utils";
import {
  AppStoreButton,
  GooglePlayButton,
} from "@monsterindia/global-ui-components";
import React from "react";

import { getFooterData } from "@/components/common/Footer/query";
import { RightFooterData } from "@/components/common/Footer/types";

import Skeleton from "./skeleton";

const DownloadApp: React.FC = () => {
  const { data, isLoading, isError } = getFooterData();
  const { hostname, isMobile } = useLogin();

  if (isLoading) return <Skeleton />;
  if (isError) return <div>Error loading data. Please try again later.</div>;

  const RightFooterData: RightFooterData = prepareRightFooterData(
    data?.MODULE_RIGHT_FOOTER_REACT_CORE || [],
    hostname,
  );

  const { downloadApp } = RightFooterData;

  const getAppImage = (imageName: string) => {
    if (imageName.toLowerCase().includes("ios")) {
      return AppStore.src;
    }
    return GooglePlay.src;
  };

  return (
    <section className={`max-md:mt-8 max-md:bg-neutral-100 max-md:px-6`}>
      <div
        className={`mt-[52px] flex w-full flex-col items-center justify-center gap-3 rounded-2xl p-4 max-md:bg-white max-md:!py-8 ${isMobile ? "border-border-subtle border border-t" : "border border-[color:var(--Border-Subtle,#E8E8EB)]"}`}
      >
        <p className="w-[277px] text-center text-xs leading-4 text-gray-700">
          Your dream job is a click away! Get the app on your mobile
        </p>
        <div className="flex justify-center gap-1.5">
          <div className="h-full w-fit max-md:hidden">
            <img
              src="https://media.foundit.in/trex/public/default/images/common/QRLogin.webp"
              alt="QR Code"
              className="h-full w-[74px] object-contain"
            />
          </div>
          <div className="flex h-full flex-col-reverse gap-1.5 max-md:!flex-row-reverse">
            <AppStoreButton
              variant="light"
              scale={11}
              className="h-[35px] w-[110px]"
            />
            <GooglePlayButton
              variant="light"
              scale={11}
              className="h-[35px] w-[110px]"
            />
            {/* {downloadApp.map((app, index) => (
              <a
                key={index}
                href={app.link_rewrite}
                target="_blank"
                rel="noopener noreferrer"
                className="flex w-[100px] justify-center rounded-lg border-[0.74px] border-solid border-[color:var(--Border-Subtle,#E8E8EB)] bg-white px-2 py-1.5"
              >
                <img
                  src={getAppImage(app.imageName)}
                  alt={app.imageName}
                  className="h-full w-full object-contain"
                />
              </a>
            ))} */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadApp;
